import { ICurrentUser } from "../../authentication/types";
import { checkEnterprisePermission } from "../../authentication/utils";

const INTERNAL_POC_MANAGER_ROLES = new Set(["root", "admin"]);

export const canAccessPOCAccounts = (currentUser: ICurrentUser | null | undefined) => {
    if (!currentUser) return false;
    if (!currentUser.enterpriseAccountId) return INTERNAL_POC_MANAGER_ROLES.has(currentUser.role);
    return checkEnterprisePermission(currentUser.enterpriseRoles, "billing", "manage");
};

export const canManagePOCAccounts = (currentUser: ICurrentUser | null | undefined) => {
    return canAccessPOCAccounts(currentUser);
};
